import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JsonHalCollection } from 'src/app/models/api/jsonhal.model';
import { InLineControlModel } from 'src/app/models/api/inLineControl.model';
import { EdgeRule, EdgeRulePolicy } from 'src/app/models/viewModels/InLineControlRulesViewModel';
import { environment } from 'src/environments/environment';
import { MicroserviceHttpService } from '../http/microservice-http.service';
import { LoggerService } from '../../infra/logger/logger.service';

@Injectable({
  providedIn: 'root',
})
export class PoliciesInLineControlRulesHttpService {
  public readonly defaultPageSize: number = 50;
  private readonly _httpService: MicroserviceHttpService;

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _logger: LoggerService
  ) {
    this._httpService = new MicroserviceHttpService(
      this._httpClient,
      'ai-edge-manager' as keyof typeof environment.services,
      this._logger
    );
  }

  public getEdgePolicyForAccount(integrationId: string): Observable<EdgeRule[]> {
    const httpParams = new HttpParams().append('integrationId', integrationId);
    return this._httpService.get<EdgeRule[]>(`effective-rules`, undefined, httpParams);
  }

  public getInLineControlsByContinuationToken(
    continuationToken: string
  ): Observable<JsonHalCollection<InLineControlModel>> {
    const url = 'detection/in-line-controls-pages';
    const httpParams = new HttpParams().append('continuationToken', continuationToken);
    return this._httpService.get<JsonHalCollection<InLineControlModel>>(url, undefined, httpParams, true);
  }

  public updateEdgeRule(
    policyId: string | undefined,
    ruleId: string,
    rulePolicy: EdgeRulePolicy,
    integrationId: string
  ): Observable<void> {
    const url = policyId ? `policy/${policyId}/rule/${ruleId}` : `policy//rule/${ruleId}`;
    const httpParams = new HttpParams().append('integrationId', integrationId);
    return this._httpService.put<void, EdgeRulePolicy>(url, rulePolicy, undefined, httpParams);
  }
}
